var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSquarePlus = function SvgSquarePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.31 0H5.69A5.69 5.69 0 0 0 0 5.68v8.63A5.69 5.69 0 0 0 5.69 20h8.63A5.69 5.69 0 0 0 20 14.32V5.68A5.69 5.69 0 0 0 14.31 0ZM18 14.32A3.69 3.69 0 0 1 14.31 18H5.69A3.69 3.69 0 0 1 2 14.32V5.68A3.69 3.69 0 0 1 5.69 2h8.63A3.69 3.69 0 0 1 18 5.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.43 9H11V5.57a1 1 0 0 0-2 0V9H5.57a1 1 0 0 0 0 2H9v3.43a1 1 0 0 0 2 0V11h3.43a1 1 0 0 0 0-2Z"
  })));
};
export default SvgSquarePlus;